{
  "tickets.actions.assign": "Assign",
  "tickets.actions.assignToMe": "Assign to me",
  "tickets.actions.claimedToast": "Ticket assigned to you",
  "tickets.actions.claimError": "Could not claim the ticket. Please try again later.",
  "tickets.actions.cancel": "Cancel",
  "tickets.actions.close": "Close",
  "tickets.actions.changePriority": "Change priority",
  "tickets.actions.clearFilters": "Clear filters",
  "tickets.actions.create": "Create ticket",
  "tickets.actions.download": "Download",
  "tickets.actions.export": "Export",
  "tickets.actions.exportUnavailable": "Export is not connected to the server yet.",
  "tickets.actions.leave": "Leave ticket",
  "tickets.actions.refresh": "Refresh",
  "tickets.actions.reopen": "Reopen",
  "tickets.actions.resolve": "Mark as resolved",
  "tickets.actions.resume": "Resume",
  "tickets.actions.updating": "Updating",
  "tickets.actions.view": "View ticket",
  "tickets.actions.wait": "Set to pending",
  "tickets.activity.collapseEvents": "Collapse",
  "tickets.activity.emptyDescription": "Status changes and internal messages will appear here.",
  "tickets.activity.emptyTitle": "No activity yet",
  "tickets.activity.expandEvents": "Show all {count} activity events",
  "tickets.activity.failed": "Failed to send",
  "tickets.activity.internalMessage": "Internal message",
  "tickets.activity.scrollToBottom": "Scroll to bottom",
  "tickets.activity.scrollToBottomAria": "Scroll to the bottom of the activity",
  "tickets.activity.sending": "Sending",
  "tickets.activity.sendingInternalMessage": "Sending internal message",
  "tickets.activity.sent": "Sent",
  "tickets.activity.systemAuthor": "System",
  "tickets.activity.timelineAria": "Internal activity timeline",
  "tickets.ai.alternativeReasonFallback": "Semantically similar and suitable as an alternative",
  "tickets.ai.applied": "AI suggestion applied · {confidence}",
  "tickets.ai.appliedToast": "AI suggestion applied: {category}",
  "tickets.ai.apply": "Apply",
  "tickets.ai.applyCategoryAria": "Apply category {category}",
  "tickets.ai.applyError": "Could not apply the AI suggestion. The previous category has been restored.",
  "tickets.ai.applying": "Applying suggestion…",
  "tickets.ai.applyingCategory": "Applying AI category",
  "tickets.ai.applyingCategoryAria": "Applying category {category}",
  "tickets.ai.applyingShort": "Applying",
  "tickets.ai.bestMatch": "Best match",
  "tickets.ai.bestReasonFallback": "Strong semantic match for the ticket's main request",
  "tickets.ai.categoryFallback": "Category {id}",
  "tickets.ai.classification": "AI classification",
  "tickets.ai.currentReasonable": "Current category looks right · {confidence}",
  "tickets.ai.generate": "Generate suggestion",
  "tickets.ai.generateError": "Could not generate an AI suggestion. Please try again later.",
  "tickets.ai.generatedToast": "AI classification suggestions generated",
  "tickets.ai.generating": "Generating AI classification",
  "tickets.ai.generatingAria": "Generating AI classification suggestions",
  "tickets.ai.noMatch": "AI could not find a suitable category",
  "tickets.ai.otherSuggestions": "{count} other suggestions",
  "tickets.ai.progress.analyzing": "Analyzing the main request…",
  "tickets.ai.progress.evaluating": "Evaluating suggestion confidence…",
  "tickets.ai.progress.matching": "Matching the category structure…",
  "tickets.ai.progress.reading": "Reading ticket information…",
  "tickets.ai.regenerate": "Generate again",
  "tickets.ai.review": "AI review",
  "tickets.ai.reviewAria": "Use AI to review the current category",
  "tickets.assignment.assignedTo": "Assigned to {assignee}",
  "tickets.assignment.assignedToTeam": "Assigned to {team}",
  "tickets.assignment.assigneeFailed": "Could not assign the follow-up agent. Please try again later.",
  "tickets.assignment.dialogDescription": "Choose the support team responsible for this ticket and optionally assign a follow-up agent.",
  "tickets.assignment.dialogTitle": "Assign ticket",
  "tickets.assignment.failed": "Assignment failed. Please try again later.",
  "tickets.assignment.loadingMembers": "Loading team members",
  "tickets.assignment.loadingTeams": "Loading support teams",
  "tickets.assignment.noAssignee": "Do not assign a follow-up agent",
  "tickets.assignment.noEligibleMembers": "This team has no available members. You can still assign only the support team.",
  "tickets.assignment.noEligibleTeams": "This project has no active support teams available for assignment.",
  "tickets.assignment.noTeam": "No support team assigned",
  "tickets.assignment.none": "No support team or follow-up agent assigned",
  "tickets.assignment.openDialogAria": "Assign support team and follow-up agent",
  "tickets.assignment.optionsError": "Could not load assignment options. Close the dialog and try again.",
  "tickets.assignment.partialError": "The support team was updated, but the follow-up agent could not be assigned: {message}",
  "tickets.assignment.pending": "Unassigned",
  "tickets.assignment.pendingAssignee": "Follow-up agent not assigned",
  "tickets.assignment.save": "Save assignment",
  "tickets.assignment.saving": "Saving assignment",
  "tickets.assignment.selectAssignee": "Select a follow-up agent",
  "tickets.assignment.selectTeam": "Select a support team",
  "tickets.assignment.selectTeamFirst": "Select a support team first",
  "tickets.assignment.team": "Support team",
  "tickets.assignment.teamFallback": "Support team",
  "tickets.assignment.unassigned": "Unassigned",
  "tickets.assignment.unknownMember": "Unknown member",
  "tickets.assignment.unknownTeam": "Unknown support team",
  "tickets.assignment.willUnassign": "Saving will also remove {assignee}'s follow-up assignment.",
  "tickets.attachment.downloadError": "Could not download this attachment. Please try again later.",
  "tickets.attachment.downloading": "Downloading attachment",
  "tickets.attachment.emptyDescription": "Add files in the editor below. They will appear here after they are sent with a message.",
  "tickets.attachment.emptyFile": "(Empty file)",
  "tickets.attachment.emptyTitle": "No attachments yet",
  "tickets.attachment.loading": "Loading attachments…",
  "tickets.attachment.messageListAria": "Message attachments",
  "tickets.attachment.noRemoteSource": "This attachment has no server source.",
  "tickets.attachment.openAria": "Open attachment {name}",
  "tickets.attachment.previewAria": "Preview attachment {name}",
  "tickets.attachment.previewError": "Could not read this attachment. Try again later or download it instead.",
  "tickets.attachment.previewTitle": "Attachment preview",
  "tickets.attachment.previewTruncated": "…Preview limited to the first 200 KB",
  "tickets.attachment.previewUnsupported": "This file type cannot be previewed here. Download it to view the file.",
  "tickets.attachment.reading": "Reading attachment…",
  "tickets.attachment.ticketListAria": "Ticket attachments",
  "tickets.attachment.type.archive": "Archive",
  "tickets.attachment.type.audio": "Audio",
  "tickets.attachment.type.document": "Document",
  "tickets.attachment.type.file": "File",
  "tickets.attachment.type.image": "Image",
  "tickets.attachment.type.pdf": "PDF",
  "tickets.attachment.type.presentation": "Presentation",
  "tickets.attachment.type.spreadsheet": "Spreadsheet",
  "tickets.attachment.type.text": "Text file",
  "tickets.attachment.type.video": "Video",
  "tickets.bulk.ariaLabel": "Bulk actions",
  "tickets.bulk.clearSelection": "Clear selection",
  "tickets.bulk.selectedCount": "{count} tickets selected",
  "tickets.bulk.selectionStatus": "Selection status",
  "tickets.bulk.unavailable": "{action} is not connected to the server yet.",
  "tickets.category.uncategorized": "Uncategorized",
  "tickets.channel.api": "API",
  "tickets.channel.phone": "Phone",
  "tickets.channel.unknown": "—",
  "tickets.channel.web": "Web",
  "tickets.composer.addAttachmentAria": "Add attachment",
  "tickets.composer.attachmentCount": "Attachments {count}/{max}",
  "tickets.composer.attachmentLimit": "You can add up to {count} attachments",
  "tickets.composer.attachmentsUploading": "Attachments are uploading…",
  "tickets.composer.cancelledHint": "This ticket is cancelled. You can no longer add messages.",
  "tickets.composer.closedHint": "This ticket is closed. You can no longer add messages.",
  "tickets.composer.contentAria": "Internal message content",
  "tickets.composer.dropFiles": "Drop to add files",
  "tickets.composer.duplicatesIgnored": "Ignored {count} duplicate files",
  "tickets.composer.failedUploadHint": "An attachment failed to upload. Retry or remove it.",
  "tickets.composer.fileUploading": "Uploading {name}",
  "tickets.composer.longPasteConverted": "The long pasted content was converted to a text attachment",
  "tickets.composer.mention.currentTeam": "{team} · Current support team",
  "tickets.composer.mention.duplicateName": "Same name",
  "tickets.composer.mention.empty": "No matching people",
  "tickets.composer.mention.error": "Could not load people. Please try again later.",
  "tickets.composer.mention.hasMore": "More results are available. Keep typing to narrow the list.",
  "tickets.composer.mention.identifier": "Member ID ending in {identifier}",
  "tickets.composer.mention.loading": "Loading…",
  "tickets.composer.mention.loadingCandidates": "Loading people",
  "tickets.composer.mention.searching": "Searching for people",
  "tickets.composer.mention.title": "Mention people",
  "tickets.composer.mention.ungrouped": "Ungrouped members",
  "tickets.composer.mentionCollaboratorAria": "Mention a collaborator",
  "tickets.composer.oversizedFiles": "{files} exceed the {maxSize} limit",
  "tickets.composer.pasteHint": "Paste images, PDFs, text, or Office files directly",
  "tickets.composer.pastedTextFileName": "pasted-text.txt",
  "tickets.composer.pendingAttachmentsAria": "Attachments waiting to be sent",
  "tickets.composer.placeholder": "Record troubleshooting progress, type @ to mention a collaborator, or paste files directly…",
  "tickets.composer.removeAttachmentAria": "Remove attachment {name}",
  "tickets.composer.resolveFailedUploadsTitle": "Retry or remove failed uploads first",
  "tickets.composer.retryUploadAria": "Upload {name} again",
  "tickets.composer.submitAria": "Add internal message",
  "tickets.composer.submitShortcut": "⌘ + Enter to add",
  "tickets.composer.supportedFilesTitle": "Supports images, PDFs, text, Office files, archives, audio, and video up to {maxSize} each",
  "tickets.composer.unsupportedFiles": "Unsupported file type: {files}",
  "tickets.composer.uploadFailed": "Upload failed",
  "tickets.composer.uploadFailureAria": "Upload failed: {reason}",
  "tickets.composer.uploadInProgressTitle": "Attachments are still uploading",
  "tickets.composer.uploading": "Uploading",
  "tickets.customer.empty": "No customer information recorded",
  "tickets.customer.noContact": "No contact details recorded",
  "tickets.customer.profile": "Customer profile",
  "tickets.customer.snapshot": "Submission snapshot",
  "tickets.customer.unnamed": "Unnamed customer",
  "tickets.customer.viewDetails": "View customer",
  "tickets.detail.archive": "Archive ticket",
  "tickets.detail.archiveUnavailable": "Archiving tickets is not connected to the server yet.",
  "tickets.detail.bodyLabel": "Ticket content",
  "tickets.detail.collapseBody": "Collapse content",
  "tickets.detail.copyLink": "Copy ticket link",
  "tickets.detail.createdAt": "Created {time}",
  "tickets.detail.expandBody": "Show full content",
  "tickets.detail.follow": "Follow ticket",
  "tickets.detail.followUnavailable": "Following tickets is not connected to the server yet.",
  "tickets.detail.from": "From",
  "tickets.detail.linkCopied": "Ticket link copied",
  "tickets.detail.loading": "Loading ticket…",
  "tickets.detail.loadingDetail": "Loading ticket details…",
  "tickets.detail.moreActionsAria": "More ticket actions",
  "tickets.detail.noBody": "This ticket has no body content.",
  "tickets.detail.notLoaded": "Ticket details have not finished loading.",
  "tickets.detail.resolvedAria": "Ticket is resolved",
  "tickets.detail.resolvedToast": "Ticket marked as resolved",
  "tickets.resolution.dialogTitle": "Resolve ticket",
  "tickets.resolution.dialogDescription": "Record the result and how you informed the requester for ticket #{number}.",
  "tickets.resolution.resultLabel": "Resolution result",
  "tickets.resolution.resultPlaceholder": "Describe what was done and the final result (up to 4,000 characters)",
  "tickets.resolution.feedbackMethodLabel": "How the requester was informed",
  "tickets.resolution.feedbackSummary": "Requester informed via {method}",
  "tickets.resolution.method.phone": "Phone",
  "tickets.resolution.method.sms": "SMS",
  "tickets.resolution.method.email": "Email",
  "tickets.resolution.method.other": "Other",
  "tickets.resolution.otherLabel": "Specify the method",
  "tickets.resolution.otherPlaceholder": "For example, in person or via a messaging app",
  "tickets.resolution.recordOnlyHint": "Record how you have already informed the requester. This action does not send a message.",
  "tickets.resolution.submit": "Save and resolve",
  "tickets.resolution.submitting": "Resolving…",
  "tickets.resolution.concurrencyError": "This ticket has changed. Your entries have been kept. Review its current status before trying again.",
  "tickets.resolution.statusChangedError": "This ticket is no longer open and cannot be resolved. Your entries have been kept. Review the ticket status.",
  "tickets.resolution.validation.resultRequired": "Enter the resolution result.",
  "tickets.resolution.validation.resultTooLong": "The result must be no longer than 4,000 characters.",
  "tickets.resolution.validation.methodRequired": "Choose how the requester was informed.",
  "tickets.resolution.validation.otherRequired": "Specify how the requester was informed.",
  "tickets.resolution.validation.otherTooLong": "The method must be no longer than 100 characters.",
  "tickets.resolution.activityTitle": "Resolution record",
  "tickets.resolution.expandResult": "Show full result",
  "tickets.resolution.collapseResult": "Collapse result",
  "tickets.resolution.otherDisplay": "Other ({method})",
  "tickets.detail.returnToList": "Back to list",
  "tickets.detail.statusUpdateError": "Could not update the status. Please try again.",
  "tickets.detail.statusUpdating": "Updating status",
  "tickets.detail.tabs.activities": "Activities",
  "tickets.detail.tabs.attachments": "Attachments",
  "tickets.detail.tabs.linkedEntities": "Linked records",
  "tickets.detail.tabs.properties": "Properties",
  "tickets.detail.via": "Via",
  "tickets.fields.actions": "Actions",
  "tickets.fields.assignee": "Follow-up agent",
  "tickets.fields.assignment": "Assignment",
  "tickets.fields.category": "Category",
  "tickets.fields.channel": "Channel",
  "tickets.fields.closedAt": "Closed",
  "tickets.fields.creationTime": "Created",
  "tickets.fields.customer": "Customer",
  "tickets.fields.extendedInfo": "Extended details",
  "tickets.fields.firstResponseAt": "First response",
  "tickets.fields.lastUpdated": "Last updated",
  "tickets.fields.number": "Ticket number",
  "tickets.fields.participants": "Collaborators",
  "tickets.fields.priority": "Priority",
  "tickets.fields.project": "Project",
  "tickets.fields.requesterSnapshot": "Contact details",
  "tickets.fields.resolvedAt": "Resolved",
  "tickets.fields.status": "Status",
  "tickets.fields.subject": "Subject",
  "tickets.fields.ticketExtendedInfo": "Ticket extended details",
  "tickets.linked.copiedToast": "Record ID copied",
  "tickets.linked.copyIdAria": "Copy {entityType} ID",
  "tickets.linked.emptyDescription": "Orders, accounts, and other records submitted with the ticket will appear here.",
  "tickets.linked.emptyTitle": "No linked records",
  "tickets.linked.linkedAt": "Linked {time}",
  "tickets.linked.listAria": "Records linked to this ticket",
  "tickets.linked.loading": "Loading linked records…",
  "tickets.linked.viewExtendedData": "View extended data",
  "tickets.linked.downloadFailed": "Could not download the linked file",
  "tickets.callRecord.type": "Call record",
  "tickets.callRecord.time": "Call time",
  "tickets.callRecord.duration": "Duration",
  "tickets.callRecord.agent": "Agent",
  "tickets.recording.title": "Call recording",
  "tickets.recording.play": "Play recording",
  "tickets.recording.pause": "Pause recording",
  "tickets.recording.seek": "Playback position",
  "tickets.recording.speed": "Playback speed",
  "tickets.recording.download": "Download recording",
  "tickets.recording.loading": "Loading recording…",
  "tickets.recording.unavailable": "No recording available",
  "tickets.recording.loadFailed": "Unable to load the recording. Select play or download to retry.",
  "tickets.recording.playFailed": "Unable to play. Try play again, or download the recording if this format is unsupported.",
  "tickets.linked.sourceRecordMissing": "The external source could not find this record",
  "tickets.linked.sourceUnavailable": "The external source is unavailable. The linked ID is still saved.",
  "tickets.list.emptyDescription": "New tickets will appear here.",
  "tickets.list.emptyFilteredDescription": "Try adjusting the search term or filters.",
  "tickets.list.emptyFilteredTitle": "No matching tickets",
  "tickets.list.emptyTitle": "No tickets yet",
  "tickets.list.lastUpdated": "Last updated {time}",
  "tickets.list.loading": "Loading tickets…",
  "tickets.list.loadingList": "Loading ticket list…",
  "tickets.list.messageCount": "{count} messages",
  "tickets.list.refreshing": "Refreshing tickets",
  "tickets.list.searchAria": "Search tickets",
  "tickets.list.searchPlaceholder": "Search ticket number or subject…",
  "tickets.list.selectAll": "Select all tickets in the current list",
  "tickets.list.selectTicket": "Select {number}",
  "tickets.list.ticketActions": "Actions for {number}",
  "tickets.new.createdToast": "Ticket created and added to the unassigned queue",
  "tickets.new.description": "Record a customer issue and route it to the right support queue.",
  "tickets.new.issueDescription": "Issue description",
  "tickets.new.issuePlaceholder": "Add customer context, symptoms, and troubleshooting steps already attempted…",
  "tickets.new.subjectPlaceholder": "Briefly describe the customer's issue",
  "tickets.new.submit": "Create ticket",
  "tickets.new.title": "New ticket",
  "tickets.new.trigger": "New ticket",
  "tickets.new.validation.issueRequired": "Enter an issue description.",
  "tickets.new.validation.subjectRequired": "Enter a ticket subject.",
  "tickets.participants.countAria": "{count} collaborators",
  "tickets.participants.empty": "No collaborators",
  "tickets.participants.hiddenCountAria": "{count} additional collaborators",
  "tickets.priority.ariaLabel": "{priority} priority",
  "tickets.priority.high": "High",
  "tickets.priority.low": "Low",
  "tickets.priority.medium": "Medium",
  "tickets.priority.normal": "Normal",
  "tickets.new.automaticPriority": "Automatic (from category)",
  "tickets.priority.unknown": "Unknown",
  "tickets.priority.urgent": "Urgent",
  "tickets.project.unspecified": "No project specified",
  "tickets.properties.state": "Ticket state",
  "tickets.properties.categoryRemoved": "Ticket category removed",
  "tickets.properties.categoryUpdateError": "Could not update the category. The previous category has been restored.",
  "tickets.properties.categoryUpdated": "Category updated to {category}",
  "tickets.properties.categoryUpdating": "Updating category",
  "tickets.properties.followUp": "Support team and follow-up agent",
  "tickets.properties.priorityUpdateError": "Could not update the priority. The previous priority has been restored.",
  "tickets.properties.priorityUpdated": "Priority updated to {priority}",
  "tickets.properties.priorityUpdating": "Updating priority",
  "tickets.properties.statusUpdateError": "Could not update the status. The previous status has been restored.",
  "tickets.properties.statusUpdated": "Status updated to {status}",
  "tickets.properties.statusUpdating": "Updating status",
  "tickets.status.cancelled": "Cancelled",
  "tickets.status.closed": "Closed",
  "tickets.status.new": "New",
  "tickets.status.open": "In progress",
  "tickets.status.pending": "Pending",
  "tickets.status.resolved": "Resolved",
  "tickets.status.unknown": "Unknown",
  "tickets.tabs.active": "In progress",
  "tickets.tabs.all": "All",
  "tickets.tabs.pending": "Pending",
  "tickets.tabs.resolved": "Resolved",
  "tickets.tabs.closed": "Closed",
  "tickets.tags.unknown": "Unknown tag",
  "tickets.time.justNow": "Just now",
  "tickets.timeline.assigned.actor": "{actor} assigned the ticket to {to}",
  "tickets.timeline.assigned.system": "Ticket assigned to {to}",
  "tickets.timeline.attachmentAdded.actor": "{actor} added an attachment",
  "tickets.timeline.attachmentAdded.system": "An attachment was added",
  "tickets.timeline.categoryChanged.actor": "{actor} changed the category to {to}",
  "tickets.timeline.categoryChanged.system": "Category changed to {to}",
  "tickets.timeline.categoryCleared.actor": "{actor} cleared the category",
  "tickets.timeline.categoryCleared.system": "Category cleared",
  "tickets.timeline.contentUpdated.actor": "{actor} updated the ticket content",
  "tickets.timeline.contentUpdated.system": "Ticket content updated",
  "tickets.timeline.created.actor": "{actor} created the ticket",
  "tickets.timeline.created.system": "Ticket created",
  "tickets.timeline.customerChanged.actor": "{actor} changed the linked customer to {to}",
  "tickets.timeline.customerChanged.system": "Linked customer changed to {to}",
  "tickets.timeline.customerCleared.actor": "{actor} removed the linked customer",
  "tickets.timeline.customerCleared.system": "Linked customer removed",
  "tickets.timeline.participantAdded.actor": "{actor} added {to} as a collaborator",
  "tickets.timeline.participantAdded.system": "{to} was added as a collaborator",
  "tickets.timeline.participantRemoved.actor": "{actor} removed {from} as a collaborator",
  "tickets.timeline.participantRemoved.system": "{from} was removed as a collaborator",
  "tickets.timeline.priorityChanged.actor": "{actor} changed the priority from {from} to {to}",
  "tickets.timeline.priorityChanged.system": "Priority changed from {from} to {to}",
  "tickets.timeline.routed.actor": "{actor} routed the ticket to {to}",
  "tickets.timeline.routed.system": "Ticket routed to {to}",
  "tickets.timeline.statusChanged.actor": "{actor} changed the status from {from} to {to}",
  "tickets.timeline.statusChanged.system": "Status changed from {from} to {to}",
  "tickets.timeline.tagAdded.actor": "{actor} added the tag {to}",
  "tickets.timeline.tagAdded.system": "Tag {to} added",
  "tickets.timeline.tagRemoved.actor": "{actor} removed the tag {from}",
  "tickets.timeline.tagRemoved.system": "Tag {from} removed",
  "tickets.timeline.unassigned.actor": "{actor} removed the assignment",
  "tickets.timeline.unassigned.system": "Assignment removed",
  "tickets.timeline.unassignedFrom.actor": "{actor} unassigned {from}",
  "tickets.timeline.unassignedFrom.system": "{from} was unassigned",
  "tickets.timeline.unknown.actor": "{actor} performed {action}",
  "tickets.timeline.unknown.system": "Performed {action}",
  "tickets.timeline.unknownAction": "unknown action",
  "triage.queueCount": "{count} waiting for a category",
  "triage.emptyTitle": "All caught up",
  "triage.emptyDescription": "Nothing is waiting for a category. New tickets will show up here.",
  "triage.panelEmptyTitle": "Pick a ticket to categorize",
  "triage.panelEmptyDescription": "Select a ticket in the queue to see its body and category suggestions.",
  "triage.noBody": "This ticket has no body. Open it to read the follow-up messages.",
  "triage.openTicket": "Open ticket",
  "triage.pickCategory": "Choose a category…",
  "triage.skip": "Skip",
  "triage.shortcutHint": "↑↓ move · Enter accepts · 1/2/3 pick · / choose category",
  "triage.categorizedToast": "Categorized as {category}",
  "triage.aiAppliedToast": "AI suggestion applied",
  "triage.bulkPickCategory": "Set category for selected…",
  "triage.bulkCategorizedToast": "Categorized {count} tickets as {category}",
  "triage.bulkPartialToast": "{succeeded} categorized, {failed} failed",
  "triage.bulkCrossProject": "Across {count} projects — only shared categories apply",
  "triage.bulkError": "Bulk categorization failed. Please try again.",
  "triage.applyConfident": "Accept {count} confident suggestions",
  "triage.aiBatchAppliedToast": "Applied {count} AI suggestions",
  "triage.panelSheetTitle": "Categorize ticket"
}
